import { useMemo } from "react";

import { usePathname } from "next/navigation";

/**
 * Custom hook to extract the current search ID from the URL pathname.
 * Returns the search ID if on a results page (/results/{id}), null otherwise.
 */
export function useCurrentSearchId(): string | null {
  const pathname = usePathname();

  return useMemo(() => {
    if (!pathname) return null;
    if (!pathname.startsWith("/results/")) return null;

    const parts = pathname.split("/results/")[1];
    if (!parts) return null;

    const searchId = parts.split("/")[0];
    return searchId || null;
  }, [pathname]);
}
